<table class="scene-table">
  <thead>
  <tr>
    <th class="col-label">Jugada</th>
    <th class="col-time">Inicio</th>
    <th class="col-time">Fin</th>

    <th class="col-team">Atacante</th>
    <th class="col-team">Defensor</th>

    @for (col of dynamicColumns; track col) {
      <th class="col-dynamic">
        <div class="column-header">
          <span>{{ col }}</span>
          @if (isPlayModelColumn(col)) {
            <button
              mat-icon-button
              type="button"
              class="help-button"
              (click)="openPlayModelHelp($event)"
              matTooltip="Explicación del modelo de juego">
              <mat-icon>help_outline</mat-icon>
            </button>
          }
        </div>
      </th>
    }
    <th class="col-actions"></th>
  </tr>
  </thead>
  <tbody>
    @for (scene of visibleScenes; track scene.id) {
      <tr
        [class.selected]="scene.id === currentScene?.id"
        [class.editing]="scene.id === editingSceneId"
      >
        @if (scene.id !== editingSceneId) {
          <td class="col-label" title="{{ scene.label }}">{{ scene.label }}</td>
          <td class="col-time">{{ formatTime(scene.start_time_in_seconds) }}</td>
          <td class="col-time">{{ formatTime(scene.end_time_in_seconds) }}</td>

          <td
            class="col-team"
            [class.default-team]="!scene.attacking_team_name && (scene.default_attacking_team_id === 1 || scene.default_attacking_team_id === 2)"
            [attr.title]="getTeamTooltip(scene, 'attacking')"
          >
            {{ getTeamDisplayName(scene, 'attacking') }}
          </td>
          <td
            class="col-team"
            [class.default-team]="!scene.defending_team_name && (scene.default_defending_team_id === 1 || scene.default_defending_team_id === 2)"
            [attr.title]="getTeamTooltip(scene, 'defending')"
          >
            {{ getTeamDisplayName(scene, 'defending') }}
          </td>

          @for (col of dynamicColumns; track col) {
            <td
              class="col-dynamic"
              [matTooltip]="getCellTooltip(scene, col)"
              [matTooltipClass]="isPlayModelColumn(col) ? 'play-model-tooltip' : ''">
              {{ getRenderedValue(scene, col) }}
            </td>
          }

          <td class="col-actions">
            <button mat-icon-button class="action-btn edit-btn"
                    (click)="startEditing(scene, $event)"
                    [disabled]="scene.id !== currentScene?.id"
                    matTooltip="Editar jugada (Solo jugada actual)">
              <mat-icon>edit</mat-icon>
            </button>

            <button mat-icon-button class="action-btn delete-btn"
                    (click)="deleteScene(scene, $event)"
                    [disabled]="scene.id !== currentScene?.id"
                    matTooltip="Eliminar jugada (Solo jugada actual)">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        }
        @else {
          <td class="col-label locked-cell">{{ scene.label }}</td>
          <td class="col-time locked-cell">{{ formatTime(scene.start_time_in_seconds) }}</td>
          <td class="col-time locked-cell">{{ formatTime(scene.end_time_in_seconds) }}</td>

          <td class="col-team locked-cell" [class.default-team]="!scene.attacking_team_name && (scene.default_attacking_team_id === 1 || scene.default_attacking_team_id === 2)" [attr.title]="getTeamTooltip(scene, 'attacking')">
            {{ getTeamDisplayName(scene, 'attacking') }}
          </td>
          <td class="col-team locked-cell" [class.default-team]="!scene.defending_team_name && (scene.default_defending_team_id === 1 || scene.default_defending_team_id === 2)" [attr.title]="getTeamTooltip(scene, 'defending')">
            {{ getTeamDisplayName(scene, 'defending') }}
          </td>

          <ng-container [formGroup]="editForm!">
            @for (col of dynamicColumns; track col) {
              <td class="col-dynamic">
                @if (isPlayModelColumn(col)) {
                  <div class="play-model-edit-wrapper">
                    <input
                      matInput
                      [formControlName]="col"
                      class="table-input"
                      placeholder="2aI-7dC-0bD"
                      (click)="$event.stopPropagation()"
                    />
                    @if (getPlayModelSoftWarning(col); as warning) {
                      <button
                        mat-icon-button
                        type="button"
                        class="warning-button"
                        (click)="$event.stopPropagation()"
                        [matTooltip]="warning">
                        <mat-icon>warning_amber</mat-icon>
                      </button>
                    }
                  </div>
                  @if (hasPlayModelFormatError(col)) {
                    <div class="field-error">Formato esperado: acción+posición separados por "-".</div>
                  }
                } @else {
                  <select [formControlName]="col" class="table-select" (click)="$event.stopPropagation()">
                    <option [ngValue]="null">-</option>
                    @for (opt of playModelOptions[col]; track opt.id) {
                      <option [ngValue]="opt.id">{{ opt.display }}</option>
                    }
                  </select>
                }
              </td>
            }
          </ng-container>

          <td class="col-actions editing-actions">
            <button mat-icon-button class="save-btn" (click)="saveEditing(scene, $event)" [disabled]="editForm?.invalid" matTooltip="Guardar">
              <mat-icon>check_circle</mat-icon>
            </button>
            <button mat-icon-button class="cancel-btn" (click)="cancelEditing()" matTooltip="Cancelar">
              <mat-icon>cancel</mat-icon>
            </button>
          </td>
        }
      </tr>
    }
    @if (visibleScenes.length === 0) {
      <tr><td colspan="100%" class="empty-msg">Sin jugadas visibles</td></tr>
    }
  </tbody>
</table>
